export default __webpack_public_path__ + "static/media/sweet3.f4ce2206.jpg";